import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useStyles from "./FileUpload.css";
import translation from "../../i18n/i18.json";
import { Button, IconButton } from "@material-ui/core";
import { Visibility, GetApp, CloudUpload } from '@material-ui/icons';
import AllActions from "../../actions";
import { FileUploadService } from "../../services/FileUploadService";
import { useDispatch } from "react-redux";
import { FileDownloadService } from "../../services/FileDownloadService";
import { fileDownloadBaseURL } from "../../services/AxiosConfig";
import { UserFile } from "../../models/UserFile";
import {
  FileUploadTypes,
  InforDisplyaDuration,
  DocumentType,
  SupportDocumentName
} from "../../constants/AppConstants";
import { RootState } from "../../reducers";
import { VendorDetailState } from "../../reducers/vendor/VendorDetailReducer";
import { ResponseObject } from "../../models/ResponseObject";
import { FileUploadResponse } from "../../models/FileUploadResponse";

interface AttachmentInputs {
  editable: boolean;
  userfile: UserFile;
  attachmentType: FileUploadTypes;
  requestNumber: string;
  onFileUpload?: (fileUploadResponse: FileUploadResponse) => any;
  isNoUpload?: boolean;
  acceptTypes?: string;
}

export default function FileUpload(props: AttachmentInputs) {
  const fileInput = useRef<HTMLInputElement>(null);
  const classes = useStyles();
  const initialFileName = "Choose File";
  const [selectedFile, setSelectedFile] = useState<any>({ name: initialFileName });
  const { editable, userfile, requestNumber, onFileUpload, isNoUpload, acceptTypes } = props;
  const dispatch = useDispatch();
  const maxfilesize = 1024 * 1024 * 4; // 1 Mb

  const getUniqueId = () => {
    return "fu_" + Math.random().toString(10).substring(2);
  };
  const inputId = getUniqueId();

  // useEffect(() => {
  //   if(selectedFile.name !== initialFileName){
  //     handleFileUpload(null);
  //   }
  // }, [selectedFile]);

  const onChangeFile = (e: any) => {
    if (e.target.files[0] && e.target.files[0].size > maxfilesize) {
      setSelectedFile({ name: initialFileName });
      e.target.value = null;
      dispatch(
        AllActions.infoActions.openInforError(
          translation.file_upload_size_exd_msg,
          InforDisplyaDuration.common
        )
      );
    } else {
      let file = e.target.files[0] ? e.target.files[0] : { name: initialFileName };
      setSelectedFile(file);
      handleFileUpload(file);
    }
    // selectedFile = e.target.files[0]
  };

  const handleFileClick = () => {
    if (fileInput.current) {
      fileInput.current.click();
    }
  };

  const handleFileUpload = (file: any) => {
    if (file.name === initialFileName) {
      dispatch(
        AllActions.infoActions.openInforError(
          translation.file_upload_select_file,
          InforDisplyaDuration.common
        )
      );
      return;
    }
    const formData = new FormData();
    formData.append("fileToUpload", file);
    formData.append("fileName", file.name);
    formData.append("UploadType", props.attachmentType.toString());
    formData.append("RequestNo", requestNumber);
    formData.append("Id", userfile ? userfile.fileId.toString() : '');
    //UserProfileService.uploadUserAttachment(formData , uploadCallBack, errorLogFunc);
    prepareForRequest();
    if (!isNoUpload) {
      FileUploadService.uploadFile(
        formData,
        function (fileUploadData: ResponseObject) {
          if (fileUploadData && fileUploadData.result) {
            let fileResponse = fileUploadData.result as FileUploadResponse;
            if (fileResponse.errors && fileResponse.errors.length > 0) {
              compeleteRequest(false, translation.file_upload_errr_millevaluation_msg + fileResponse.errors);
              return;
            } else {
              if (userfile) {
                userfile.fileId = Number(fileResponse.fileId);
                userfile.fileName = file.name;
              }
              if (onFileUpload) {     
                   onFileUpload(fileResponse);
             
              }
              setSelectedFile({ name: initialFileName });
              compeleteRequest(true, translation.file_upload_success_msg);
            }
          } 
          else if(fileUploadData.message==translation.file_upload_errr_worng_mill_type_msg)
          {
                console.log(fileUploadData);
                compeleteRequest(false, translation.file_upload_errr_worng_mill_type_msg);
          }
          else {
            console.log(fileUploadData);
            compeleteRequest(false, translation.file_upload_errr_worng_type_msg);
          }
        },
        function (error: Error) {
          compeleteRequest(false, translation.file_upload_errr_msg);
        }
      );
    } else {
      setSelectedFile(file);
      if (userfile) {
        userfile.fileName = file.name;
      }
      compeleteRequest(true)
    }
  };

  const handleDownload = (isView: boolean, isDownload: boolean) => {
    // e.preventDefault();
    prepareForRequest();
    FileDownloadService.downlodFile(
      userfile,
      isDownload,
      isView,
      DocumentType.VendorDocument,
      SupportDocumentName.SOPDocumentDarwinRm,
      function (success: any) {
        compeleteRequest(true);

      }, function (error: any) {
        compeleteRequest(false, translation.file_download_filedwnld_err);

      });
  };

  const onFileView = (e: any) => {
    handleDownload(true, false);
  };

  const onFileDownload = (e: any) => {
    handleDownload(false, true);
  };

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  return (
    <div className={editable ? classes.fileUploadEdit : classes.fileUploadView}>
      {userfile && userfile.fileName && (
        <div className={classes.fileUploadDetails}>
          <div style={{ width: "100%", display: "flex" }}>
            <span className={classes.fileNameLbl}>
              {userfile ? userfile.fileName : ""}
            </span>
            <div className={classes.btnGroup}>
              <IconButton aria-label="View" title="View" onClick={onFileView} style={{ background: "#000000" }}>
                <Visibility />
              </IconButton >
              <IconButton style={{ background: "#19c626" }} aria-label="Download" title="Download" onClick={onFileDownload}>
                <GetApp />
              </IconButton>
            </div>
          </div>
        </div>)}
      {editable && (
        <div className={classes.fileNameInput}>
          {/* <label 
            className={classes.textWrapInput} 
            htmlFor={inputId}>{selectedFile.name}</label> */}
          <input
            ref={fileInput}
            id={inputId}
            hidden={true}
            type="file"
            accept= {acceptTypes ? acceptTypes : ".PDF ,.JPG, .JPEG, .PNG, .GIF, .TIFF, .BMP, .xlsx, .ods, .eml, .msg, .docx, .pptx" }
            className="form-control"
            //value={fileName}
            name="file"
            onChange={(e) => {
              onChangeFile(e);
            }}
          />
          <IconButton
            color="primary"
            //disabled={selectedFile.name === initialFileName} 
            onClick={handleFileClick}
            title={translation.file_upload_btn_lbl}
            style={{ background: "#0faade" }}>
            <CloudUpload />
          </IconButton>
        </div>
      )}
      {/* <Button
        color="primary"
        variant="contained"
        disabled={!selectedFile}
        onClick={handleFileUpload}
      >
        {translation.file_upload_btn_lbl}
      </Button> */}
      {/* hidden={!userfile!.fileName}  */}
      {/* {userfile && (<a href={`fileDownloadBaseURL ${userfile.fileName}`}> {translation.file_dwnld_btn_lbl}</a> )} */}
    </div>
  );
}
